import { render, staticRenderFns } from "./HizmetTanimla.vue?vue&type=template&id=2c790490&scoped=true&"
import script from "./HizmetTanimla.vue?vue&type=script&lang=js&"
export * from "./HizmetTanimla.vue?vue&type=script&lang=js&"
import style0 from "./HizmetTanimla.vue?vue&type=style&index=0&id=2c790490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c790490",
  null
  
)

export default component.exports